export const AUTH_STATE_KEY = 'auth_state';
export const SELECTED_AGENCY_KEY = 'selected_agency_id';
